import { FormBase } from 'core/components';

export default class ImportPatientCreateForm extends FormBase {
    constructor(hooks) {      
        super(hooks);
    }

    setup() {
        
        return {
            fields: [
                {
                    name: 'firstName',
                    label: 'IMPORT_PATIENT.CREATE.FIRST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'lastName',
                    label: 'IMPORT_PATIENT.CREATE.LAST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'required|string'                    
                },
                {
                    name: 'gender',
                    label: 'IMPORT_PATIENT.CREATE.GENDER_LABEL',
                    placeholder: 'Enter gender',                  
                },
                {
                    name: 'dateOfBirth',
                    label: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_PLACEHOLDER',                  
                },
                {
                    name: 'phone',
                    label: 'IMPORT_PATIENT.CREATE.PHONE_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.PHONE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'address1',
                    label: 'IMPORT_PATIENT.CREATE.ADDRESS_1_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.ADDRESS_1_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'address2',
                    label: 'IMPORT_PATIENT.CREATE.ADDRESS_2_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.ADDRESS_2_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'city',
                    label: 'IMPORT_PATIENT.CREATE.CITY_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.CITY_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'state',
                    label: 'IMPORT_PATIENT.CREATE.STATE_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.STATE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode1',
                    label: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_1_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_1_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode2',
                    label: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_2_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_2_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode3',
                    label: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_3_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_3_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode4',
                    label: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_4_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODE_4_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'ssn',
                    label: 'SSN',
                    placeholder: 'Enter SSN',
                    rules: 'integer'
                },
                {
                    name: 'contactRelationship',
                    label: 'Relationship',
                    placeholder: 'Enter Relationship',
                    rules: 'string'                    
                },
                {
                    name: 'contactFirstName',
                    label: 'IMPORT_PATIENT.CREATE.FIRST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactLastName',
                    label: 'IMPORT_PATIENT.CREATE.LAST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'address',
                    label: 'Address',
                    placeholder: 'Enter Address',
                    rules: 'string'
                },
                {
                    name: 'postalCode',
                    label: 'Postal Code',
                    placeholder: 'Enter Postal Code',
                    rules: 'integer'
                },
                {
                    name: 'height',
                    label: 'Height',
                    placeholder: 'Enter Height',
                    rules: 'numeric'                    
                },
                {
                    name: 'weight',
                    label: 'Weight',
                    placeholder: 'Enter Weight',
                    rules: 'numeric'                    
                },
                {
                    name: 'primaryInsurancePayorLevel',
                    label: 'Payor Level',
                    placeholder: 'Enter Payor Level',
                    rules: ''                    
                },
                {
                    name: 'secondaryInsurancePayorLevel',
                    label: 'Payor Level',
                    placeholder: 'Enter Payor Level',
                    rules: ''                    
                },
                {
                    name: 'primaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                  
                },
                {
                    name: 'secondaryInsuranceStartDate',
                    label: 'Start Date',
                    placeholder: ''                   
                },
                {
                    name: 'diagnosisCode',
                    label: 'Diagnosis code',
                    placeholder: 'Enter diagnosis code'
                },
                {
                    name: 'diagnosisCodes',
                    label: 'Diagnosis code',
                    placeholder: 'Enter Diagnosis code'
                },
                {
                    name: 'primaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Enter Insurance'                   
                },
                {
                    name: 'secondaryInsuranceName',
                    label: 'Insurance',
                    placeholder: 'Enter Insurance'                   
                },

                // ...primaryInsurance.fields,
                // ...secondaryInsurance.fields
                // {
                //     name: 'diagnosisCodes',
                //     label: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODES_LABEL',
                //     placeholder: 'IMPORT_PATIENT.CREATE.DIAGNOSIS_CODES_PLACEHOLDER',
                //     rules: 'string',
                //     type: 'textArea'
                // }
            ],
        };
    }
}
